module.exports = __webpack_public_path__ + "img/business-report.42c5013c.png";